import { ClientSummaryActionDispatch, ClientSummaryReduxTypes } from "./types";

export const createClientSummary = (payload: any): ClientSummaryActionDispatch => ({
    type: ClientSummaryReduxTypes.CLIENT_SUMMARY_REPORT,
    payload: payload
})